import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

export default function FamilyLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/me`, { credentials: "include" });
        if (!alive || !res.ok) return;
        const data = await res.json();
        if (data?.role === "family_member") navigate("/family", { replace: true });
        else navigate("/übersicht", { replace: true });
      } catch {
        // ignore
      }
    })();
    return () => {
      alive = false;
    };
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/family/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.message || "Login fehlgeschlagen.");
      navigate("/family", { replace: true });
    } catch (error) {
      setErr(error?.message || "Login fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#DEF1FF] px-4">
      <div className="w-full max-w-md rounded-3xl border border-black/10 bg-white/80 p-8 shadow-sm backdrop-blur">
        <p className="text-sm font-medium text-blue-700">SteffiCare Familie</p>
        <h1 className="mt-2 text-3xl font-semibold text-gray-900">Familienkonto anmelden</h1>
        <p className="mt-2 text-sm text-gray-600">
          Melde dich mit deinem eingeladenen Familienkonto an.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="Email-Adresse"
            className="w-full rounded-full border border-gray-200 bg-white px-5 py-3 text-sm text-gray-900 outline-none focus:border-blue-300 focus:ring-2 focus:ring-blue-100"
          />
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Passwort"
            className="w-full rounded-full border border-gray-200 bg-white px-5 py-3 text-sm text-gray-900 outline-none focus:border-blue-300 focus:ring-2 focus:ring-blue-100"
          />

          {err ? (
            <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {err}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-blue-600 px-5 py-3 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-300"
          >
            {loading ? "Anmeldung..." : "Anmelden"}
          </button>
        </form>

        <p className="mt-6 text-sm text-gray-600">
          Noch kein Zugang? Bitte nutze den Einladungslink aus der Pflege.
        </p>
        <div className="mt-3">
          <Link to="/login" className="text-sm font-medium text-blue-700 hover:text-blue-800">
            Zurueck zum Pflege-Login
          </Link>
        </div>
      </div>
    </div>
  );
}
